<app-carousel></app-carousel>
<div *ngIf="shouldTrack()" appViewTracker [viewType]="ViewType.JobOffer"
    [entityId]="jobOffer().id || jobOfferId() || 0"></div>

<div class="body-app mt-5 mb-3">
    <div class="content-app">
        <br />
        <div class="row mb-2">
            <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <h5 class="mt-0 mb-2">
                    {{jobOffer().title}}
                </h5>
            </div>
            <div class="col-xl-6 col-lg-5 col-md-12 col-sm-12 col-12">
                <div class="text-end">
                    <button (click)="goBack()" type="button" class="btn btn-secondary me-2">
                        <i class="fa-solid fa-arrow-left"></i>
                        Volver atras
                    </button>
                    <a href="javascript:void(0);" class="d-inline-block text-decoration-none mx-2"
                        data-bs-toggle="modal" data-bs-target="#modalCompartirOfertaPublicIn"
                        (click)="beforeOpenShareModal()">
                        <i class="fa-solid fa-share-from-square"></i>
                        Compartir
                    </a>
                    <!-- <a href="javascript:void(0);" class="d-inline-block text-decoration-none mx-2"
                        data-bs-toggle="modal" data-bs-target="#modalReferirCandidato">
                        <i class="fa-solid fa-circle-user"></i>
                        Referir a un amigo
                    </a> -->
                    @if(canUserApply() && !jobOffer().appliedOffer && jobOffer().id > 0){
                    <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                        data-bs-target="#modalAplicarTrabajo">
                        <i class="fa-regular fa-circle-check"></i>
                        Aplicar al trabajo
                    </button>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12">
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="text-center">
                            @if (!isUserLoggedIn()) {
                                <img src="assets/Images/logo-compania.jpg" alt="logo" class="img-fluid"
                                    style="max-width: 120px;" />
                            } @else if (jobOffer().logoUrl) {
                                <img [src]="jobOffer().logoUrl" alt="logo" class="img-fluid" 
                                onerror="this.error=null; this.src='assets/Images/logo-compania.jpg'"
                                 style="max-width: 120px;"/>
                            } @else {
                                <img src="assets/Images/logo-compania.jpg" alt="logo" class="img-fluid"
                                    style="max-width: 120px;" />
                            }
                        </div>
                        <h5 class="mt-4 mb-3 text-center">
                            @if (!isUserLoggedIn()) {
                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                            } @else {
                                {{jobOffer().ownerFullName}}
                            }
                        </h5>
                        <div class="table-responsive">
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Compañia</span></td>
                                        <td class="text-end">
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada</span>
                                            } @else {
                                                {{jobOffer().ownerFullName}}
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Ubicación</span></td>
                                        <td class="text-end">
                                            {{ jobOffer().countryName }} / {{ jobOffer().stateName }} / {{
                                            jobOffer().cityName }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Lugar donde se
                                                desempeñara</span></td>
                                        <td class="text-end">{{jobOffer().address}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="text-start"><span class="text-secondary">Puestos</span></td>
                                        <td class="text-end">{{jobOffer().vacantPositions | number}}</td>
                                    </tr> -->
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Tipo de contratación</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().contractTypeName}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="text-start"><span class="text-secondary">Tiempo de trabajo</span></td>
                                        <td class="text-end">{{jobOffer().workingTime}}</td>
                                    </tr> -->
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Duración del contrato</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().contractDurationName}}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-start"><span class="text-secondary">Fecha de publicación</span>
                                        </td>
                                        <td class="text-end">{{(jobOffer().publicOn || jobOffer().createDate) | date: 'dd/MM/yyyy'}}</td>
                                    </tr>
                                    <!-- <tr>
                                        <td class="text-start"><span class="text-secondary">Fecha de cierre</span>
                                        </td>
                                        <td class="text-end">{{jobOffer().closeOn | date: 'dd/MM/yyyy'}}</td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                @if(canUserApply() && !jobOffer().appliedOffer){
                <div class="card mb-2">
                    <div class="card-body">
                        <div class="text-center">
                            @if(!jobOffer().appliedOffer && jobOffer().id > 0){
                                <button type="button" class="btn btn-primary btn-lg" data-bs-toggle="modal"
                                    data-bs-target="#modalAplicarTrabajo">
                                    <i class="fa-regular fa-circle-check"></i>
                                    Aplicar al trabajo
                                </button>
                            }
                        </div>
                    </div>
                </div>
                }
                @if(!isUserLoggedIn()){
                    <div class="card mb-2">
                        <div class="card-body">
                            <div class="alert alert-info">
                                <i class="fa-solid fa-info-circle me-2"></i>
                                <!-- <strong>Información privada:</strong>  -->
                                Inicia sesión para ver los detalles completos de la empresa y más ofertas laborales.
                            </div>
                        </div>
                    </div>
                }
                @if(!canUserApply() || (isLoggedIn() && !isCandidate())){
                    <div class="card mb-2">
                        <div class="card-body">
                            <div class="text-center">
                                @if(!canUserApply()){
                                    <p class="text-muted">Debe iniciar sesión para aplicar a esta oferta laboral.</p>
                                }
                                @if(isLoggedIn() && !isCandidate()){
                                    <p class="text-muted">Solo los candidatos pueden aplicar a las ofertas laborales.</p>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12">
                <!-- Acordeones con información detallada -->
                <div class="accordion" id="jobOfferAccordion">
                    <!-- Acordeón 1: Descripción y responsabilidades -->
                    <div class="accordion-item border-0 mb-3 shadow-sm">
                        <h2 class="accordion-header">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDescription" aria-expanded="true" aria-controls="collapseDescription">
                                <i class="fa fa-file-text me-2"></i> Descripción y Responsabilidades
                            </button>
                        </h2>
                        <div id="collapseDescription" class="accordion-collapse collapse show" data-bs-parent="#jobOfferAccordion">
                            <div class="accordion-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Descripción:</h6>
                                        <p>{{ jobOffer().description || 'No hay descripción disponible' }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Responsabilidades:</h6>
                                        <p>{{ jobOffer().responsabilities || 'No hay responsabilidades detalladas' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Acordeón 2: Requisitos y Habilidades -->
                    <div class="accordion-item border-0 mb-3 shadow-sm">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseRequirements" aria-expanded="false" aria-controls="collapseRequirements">
                                <i class="fa fa-list-check me-2"></i> Requisitos y Habilidades
                            </button>
                        </h2>
                        <div id="collapseRequirements" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                            <div class="accordion-body">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <h6 class="text-primary mb-2">Requisitos generales:</h6>
                                        <p>{{ jobOffer().requirenments || 'No hay requisitos especificados' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Lista de requisitos:</h6>
                                        <ul class="list-group">
                                            @for (req of jobOffer().requirementsList; track $index) {
                                                <li class="list-group-item border-0 ps-0">
                                                    <i class="fa fa-check-circle text-success me-2"></i>{{ req.name }}
                                                </li>
                                            }
                                            @if (jobOffer().requirementsList.length == 0) {
                                                <li class="list-group-item border-0 ps-0 text-muted">
                                                    No hay requisitos específicos listados
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <h6 class="text-primary mb-2">Habilidades requeridas:</h6>
                                        <ul class="list-group">
                                            @for (skill of jobOffer().skills; track $index) {
                                                <li class="list-group-item border-0 ps-0">
                                                    <i class="fa fa-check-circle text-success me-2"></i>{{ skill.name }}
                                                </li>
                                            }
                                            @if (jobOffer().skills.length == 0) {
                                                <li class="list-group-item border-0 ps-0 text-muted">
                                                    No hay habilidades específicas listadas
                                                </li>
                                            }
                                        </ul>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Certificaciones:</h6>
                                        <ul class="list-group">
                                            @for (cert of jobOffer().certifications; track $index) {
                                                <li class="list-group-item border-0 ps-0">
                                                    <i class="fa fa-certificate text-warning me-2"></i>{{ cert.name }}
                                                </li>
                                            }
                                            @if (jobOffer().certifications!.length == 0) {
                                                <li class="list-group-item border-0 ps-0 text-muted">
                                                    No hay certificaciones requeridas
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Nivel de Educación:</h6>
                                        <p><i class="fa fa-graduation-cap me-2"></i>{{ jobOffer().educationLevelName || 'No especificado' }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Experiencia Laboral:</h6>
                                        <p><i class="fa fa-briefcase me-2"></i>{{ jobOffer().workExperienceLevelName || 'No especificado' }}</p>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Idiomas requeridos:</h6>
                                        <p>{{ jobOffer().languagesRequired || 'No especificado' }}</p>
                                        <ul class="list-group">
                                            @for (lang of jobOffer().requiredLanguages; track $index) {
                                                <li class="list-group-item border-0 ps-0">
                                                    <i class="fa fa-language me-2"></i>{{ lang.name }}
                                                </li>
                                            }
                                            @if (jobOffer().requiredLanguages!.length == 0 && !jobOffer().languagesRequired) {
                                                <li class="list-group-item border-0 ps-0 text-muted">
                                                    No hay idiomas específicos requeridos
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Disponibilidad para viajar:</h6>
                                        <p><i class="fa fa-plane me-2"></i>{{ jobOffer().travelDisponibilityName || 'No especificado' }}</p>
                                        
                                        <!-- <h6 class="text-primary mb-2 mt-3">Autorización de empleo:</h6>
                                        <p>
                                            <i *ngIf="jobOffer().needEmploymentAuthorization" class="fa fa-check-circle text-success me-2"></i>
                                            <i *ngIf="!jobOffer().needEmploymentAuthorization" class="fa fa-times-circle text-danger me-2"></i>
                                            {{ jobOffer().needEmploymentAuthorization ? 'Se requiere autorización de empleo' : 'No se requiere autorización de empleo' }}
                                        </p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Acordeón 3: Beneficios -->
                    <div class="accordion-item border-0 mb-3 shadow-sm">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBenefits" aria-expanded="false" aria-controls="collapseBenefits">
                                <i class="fa fa-gift me-2"></i> Beneficios
                            </button>
                        </h2>
                        <div id="collapseBenefits" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                            <div class="accordion-body">
                                <div class="row">
                                    <div class="col-12">
                                        <h6 class="text-primary mb-2">Beneficios ofrecidos:</h6>
                                        <p>{{ jobOffer().benefits || 'No hay descripción de beneficios disponible' }}</p>
                                        
                                        <div class="row mt-3">
                                            <div class="col-md-12">
                                                <div class="d-flex flex-wrap gap-2">
                                                    @for (benefit of jobOffer().benefitsList; track $index) {
                                                        <span class="badge bg-light text-dark p-2 shadow-sm">
                                                            <i class="fa fa-check text-success me-1"></i> {{ benefit.name }}
                                                        </span>
                                                    }
                                                    @if (!jobOffer().benefitsList!.length) {
                                                        <span class="text-muted">
                                                            No hay beneficios específicos listados
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Acordeón 4: Información de contacto y aplicación -->
                    <div class="accordion-item border-0 mb-3 shadow-sm">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseContact" aria-expanded="false" aria-controls="collapseContact">
                                <i class="fa fa-address-card me-2"></i> Información de contacto
                            </button>
                        </h2>
                        <div id="collapseContact" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                            <div class="accordion-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Persona de contacto:</h6>
                                        <p><i class="fa fa-user me-2"></i>
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                            } @else {
                                                {{ jobOffer().contactInfoName || 'No especificado' }}
                                            }
                                        </p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Correo electrónico:</h6>
                                        <p><i class="fa fa-envelope me-2"></i>
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                            } @else {
                                                {{ jobOffer().contactInfoEmail || 'No especificado' }}
                                            }
                                        </p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Teléfono:</h6>
                                        <p><i class="fa fa-phone me-2"></i>
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                            } @else {
                                                {{ jobOffer().contactInfoPhone || 'No especificado' }}
                                            }
                                        </p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Método de aplicación:</h6>
                                        <p><i class="fa fa-file-upload me-2"></i>
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                            } @else {
                                                {{ jobOffer().jobApplicationMethodName || 'No especificado' }}
                                            }
                                        </p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Nombre de la empresa:</h6>
                                        <p><i class="fa fa-building me-2"></i>
                                            @if (!isUserLoggedIn()) {
                                                <span class="private-info">Información privada (Inicia sesión para ver)</span>
                                            } @else {
                                                {{ jobOffer().ownerFullName || 'No especificado' }}
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Acordeón 5: Ubicación y detalles adicionales -->
                    <div class="accordion-item border-0 mb-3 shadow-sm">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLocation" aria-expanded="false" aria-controls="collapseLocation">
                                <i class="fa fa-map-marker me-2"></i> Ubicación y detalles adicionales
                            </button>
                        </h2>
                        <div id="collapseLocation" class="accordion-collapse collapse" data-bs-parent="#jobOfferAccordion">
                            <div class="accordion-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Ubicación:</h6>
                                        <p><i class="fa fa-map-pin me-2"></i>{{ jobOffer().cityName || '' }}{{ jobOffer().stateName ? ', ' + jobOffer().stateName : '' }}{{ jobOffer().countryName ? ', ' + jobOffer().countryName : '' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Dirección:</h6>
                                        <p><i class="fa fa-home me-2"></i>{{ jobOffer().address || '' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Posibilidad de trabajo remoto:</h6>
                                        <p><i class="fa fa-laptop-house me-2"></i>{{ jobOffer().remoteWorkPossibilityName || 'No especificado' }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="text-primary mb-2">Departamento:</h6>
                                        <p><i class="fa fa-sitemap me-2"></i>{{ jobOffer().departmentName || 'No especificado' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Posición:</h6>
                                        <p><i class="fa fa-id-badge me-2"></i>{{ jobOffer().positionName || 'No especificado' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Vacantes disponibles:</h6>
                                        <p><i class="fa fa-users me-2"></i>{{ jobOffer().vacantPositions || 'No especificado' }}</p>
                                        
                                        <h6 class="text-primary mb-2 mt-3">Horario de trabajo:</h6>
                                        <p><i class="fa fa-clock me-2"></i>{{ jobOffer().workingTime || 'No especificado' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalAplicarTrabajo" tabindex="-1" aria-labelledby="modalAplicarTrabajoLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalAplicarTrabajoLabel">Aplicar al trabajo</h1>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <p class="mb-2">
                    Seleccione por favor el curriculum con el que desea aplicar al trabajo:
                </p>
                <ul class="list-group">
                    @for (item of resumes(); track $index) {
                    <li class="list-group-item">
                        <h5 class="mt-0 mb-1">
                            <div class="form-check">
                                <input [checked]="resumeId() === item.id" (change)="resumeId.set(item.id)" class="form-check-input" type="radio" name="curriculum"
                                    [id]="item.id" [value]="item.id">
                                <label class="form-check-label" for="curriculum1">
                                    {{item.name}}
                                </label>
                            </div>
                        </h5>
                        <p class="ms-4 mb-1">
                            {{item.description}}
                        </p>
                    </li>
                    }
                </ul>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button [disabled]="isLoading()" (click)="closeModal()" type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    @if(canUserApply() && !jobOffer().appliedOffer){
                    <button [disabled]="!resumeId() || isLoading()" (click)="submit()" type="button" class="btn btn-primary">
                        @if (isLoading()) {
                            <div class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <span> Cargando...</span>
                        }@else {
                             Aplicar al trabajo
                        }
                    </button>
                    }
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalReferirCandidato" tabindex="-1" aria-labelledby="modalReferirCandidatoLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalReferirCandidatoLabel">Referir candidato</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="form-group mb-3">
                    <label class="required-field">Correo electrónico de su candidato para aplicar al trabajo:</label>
                    <div class="input-group">
                        <input type="text" class="form-control" />
                        <button type="button" class="btn btn-primary">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Buscar
                        </button>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <p class="text-secondary mb-1">Candidato seleccionado:</p>
                        <h5 class="text-primary">
                            Oscar Isac Morales Estrada
                        </h5>
                    </div>
                </div>
                <hr class="mt-3 mb-3" />
                <div class="mt-2 mb-2 text-end">
                    <button type="button" class="btn btn-secondary me-2">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary">
                        Referir candidato
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalCompartirOfertaPublicIn" tabindex="-1" aria-labelledby="modalCompartirLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalCompartirLabel">Compartir</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="text-left">
                    Seleccione el medio por el cual desea compartir el link:
                </p>
                <div class="row">
                    <div class="col-6 text-center">
                        <a [href]="'mailto:?subject=Revisa esta oferta de trabajo&body=' + selectedJobUrl"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Correo electrónico">
                            <i class="fa-regular fa-envelope fa-3x"></i>
                            Correo electrónico
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://www.facebook.com/sharer/sharer.php?u=' + selectedJobUrl" target="_blank"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Facebook">
                            <i class="fa-brands fa-facebook fa-3x"></i>
                            Facebook
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" (click)="copyToClipboard()"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Instagram">
                            <i class="fa-brands fa-instagram fa-3x"></i>
                            Instagram
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://twitter.com/intent/tweet?text=Mira esta oferta de trabajo: ' + selectedJobUrl"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="X">
                            <i class="fa-brands fa-x-twitter fa-3x"></i>
                            X
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://wa.me/?text=' + selectedJobUrl" target="_blank"
                            class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Whatsapp">
                            <i class="fa-brands fa-whatsapp fa-3x"></i>
                            Whatsapp
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a [href]="'https://t.me/share/url?url=' + selectedJobUrl + '&text=Te comparto esta oferta de empleo'"
                            target="_blank" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3"
                            title="Telegram">
                            <i class="fa-brands fa-telegram fa-3x"></i>
                            Telegram
                        </a>
                    </div>
                    <div class="col-12 text-center">
                        <button class="btn btn-outline-dark mt-2" (click)="copyToClipboard()">
                            <i class="fa-regular fa-copy"></i> Copiar enlace
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>